<div class="enquiry-page-wrapper">
  <div class="success-wrapper">
    <div class="success">
      <p>Thank you for your enquiry.</p>
      <p>
        We will get back to you as soon as possible.
      </p>
      <button (click)="goHome()">Back to Gallery</button>
    </div>
  </div>
</div>
